import { Button, Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { FormSectionHeader, FormTextarea, Loader, TaskFormContainer } from "@/components";
import useNotes from "./useNotes";
import { approvedTabs, fakeTabs, NOTE, tabs } from "./consts";
import { images } from "@/assets";
import moment from "moment";
import { cn } from "@/lib/utils";

const Notes = () => {
  const { form, onSubmit, requiredFields, isAddPending, isLoadingNote, isView,
    activeTab,
    onChangeTab,
    noteListByRole,
    isPlanApproved
   } = useNotes();
  const { errors } = form.formState;

  return (
    <>
    
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid grid-cols-1 gap-[30px] pt-[20px] pb-10 px-5 no-scrollbar">
          {isView ? <></> : (
          <TaskFormContainer label="Note" isRequired wrapperClassname="grid-cols-4" innerWrapperClassname="col-span-3">
            <FormTextarea
              name={NOTE}
              control={form.control}
              label=""
              placeholder="Please enter"
              error={errors[NOTE]?.message}
              isRequired={requiredFields.includes(NOTE)}
              className="h-[120px]"
              disabled={isView}
            />
          </TaskFormContainer>
          )}
          {isView ? <></> : <div className="flex flex-row justify-end gap-3 w-full">
            <Button
              type="submit"
              value="save"
              disabled={isAddPending}
            >
              Save
            </Button>
          </div>}
          <div className={cn("pt-3", isView ? "pt-1" : "border-t-[0.5px] pt-3")}>
            <FormSectionHeader className="font-[600]">
              Note history
            </FormSectionHeader>
            <Tabs value={activeTab} defaultValue="task-planning">
              <TabsList className="bg-transparent w-full">
                {[...tabs, ...isPlanApproved ? approvedTabs : fakeTabs]?.map((data: any, index: any) => (
                  <TabsTrigger
                    key={data?.value}
                    value={data?.value}
                    onClick={() => onChangeTab(data.value)}
                    className="font-[12px]"
                    disabled={!isPlanApproved && index != 0}
                  >
                    {data?.title}
                  </TabsTrigger>
                ))}
              </TabsList>
              {/* <div className="h-[0.5px] w-[100%] bg-gray-200 "/> */}
              <div className={cn("max-h-[calc(100vh-300px)] overflow-y-scroll")}>
                <TabsContent value={activeTab}>
                  {isLoadingNote ? <Loader /> : noteListByRole?.length == 0 ? 
                    <div className="flex items-center justify-center">
                      <img src={images.no_data} className="h-[100px]" />
                    </div> : 
                    <ul className="flex flex-col gap-3">
                      {noteListByRole?.map((data: any, index: number) => 
                        <li className="text-[14px]">
                          <span className="text-yellow-700">{index+1}. Remark By: {data?.createdByName || ""} on {moment(data?.createdAt).format('MM-DD-YYYY')} - </span> {data?.note}
                        </li>
                      )}
                    </ul>
                  }
                </TabsContent>
              </div>
            </Tabs>
          </div>
        </div>
      </form>
    </FormProvider>
    </>
  );
};

export default Notes;
